import { render, staticRenderFns } from "./myQuoteList.vue?vue&type=template&id=5162bdf3&scoped=true"
import script from "./myQuoteList.vue?vue&type=script&lang=js"
export * from "./myQuoteList.vue?vue&type=script&lang=js"
import style0 from "./myQuoteList.vue?vue&type=style&index=0&id=5162bdf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162bdf3",
  null
  
)

export default component.exports